import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import e from "react";
var n = function n(_ref) {
  var n = _ref.businessName,
    a = _ref.siteUrl,
    t = _ref.businessType,
    s = _ref.logo,
    i = _ref.image,
    r = _ref.businessDescription,
    o = _ref.phoneNumber,
    d = _ref.address,
    l = _ref.city,
    p = _ref.state,
    c = _ref.zip,
    g = _ref.openSunday,
    y = _ref.sundayClosingTime,
    m = _ref.sundayOpeningTime,
    u = _ref.openMonday,
    f = _ref.mondayClosingTime,
    h = _ref.mondayOpeningTime,
    O = _ref.openTuesday,
    w = _ref.tuesdayClosingTime,
    T = _ref.tuesdayOpeningTime,
    S = _ref.openWednesday,
    $ = _ref.wednesdayClosingTime,
    C = _ref.wednesdayOpeningTime,
    v = _ref.openThursday,
    b = _ref.thursdayClosingTime,
    E = _ref.thursdayOpeningTime,
    N = _ref.openFriday,
    k = _ref.fridayClosingTime,
    R = _ref.fridayOpeningTime,
    W = _ref.openSaturday,
    P = _ref.saturdayClosingTime,
    F = _ref.saturdayOpeningTime,
    L = _ref.isNextjs,
    M = _ref.reviewsForRatingValuePart1,
    j = _ref.reviewsForRatingValuePart2,
    x = _ref.reviewsQuery,
    A = _ref.offers,
    D = _ref.awards,
    z = _ref.brands,
    H = _ref.certifications,
    J = _ref.languages,
    V = _ref.organizations,
    _ = _ref.socialProfilesDirectoryListings;
  var I = [];
  A && A.length > 0 && A.forEach(function (e) {
    var n = {
        "@type": "Offer",
        name: e.offer,
        url: e.url
      },
      a = e.offer.match(/\$(\d+\.?\d*)/);
    if (a) {
      var _a = _slicedToArray(a, 2),
        _e = _a[1];
      n.price = _e, n.priceCurrency = "USD";
    }
    I.push(n);
  });
  var U = [];
  D && D.length > 0 && D.forEach(function (e) {
    U.push(e.award);
  });
  var B = [];
  z && z.length > 0 && z.forEach(function (e) {
    B.push(e.brand);
  });
  var Q = [];
  H && H.length > 0 && H.forEach(function (e) {
    Q.push({
      "@type": "EducationalOccupationalCredential",
      credentialCategory: e.certification
    });
  });
  var q = [];
  J && J.length > 0 && J.forEach(function (e) {
    q.push(e.language);
  });
  var G = [];
  V && V.length > 0 && V.forEach(function (e) {
    G.push({
      "@type": "Organization",
      name: e.organization
    });
  });
  var K = [];
  _ && _.length > 0 && _.forEach(function (e) {
    K.push(e.socialProfileDirectory);
  });
  var X = function X(e) {
      var _e$split = e.split(" "),
        _e$split2 = _slicedToArray(_e$split, 2),
        n = _e$split2[0],
        a = _e$split2[1];
      var _n$split = n.split(":"),
        _n$split2 = _slicedToArray(_n$split, 2),
        t = _n$split2[0],
        s = _n$split2[1];
      return t = parseInt(t, 10), 12 === t && (t = 0), "PM" === a && t < 12 && (t += 12), "".concat(t.toString().padStart(2, "0"), ":").concat(s);
    },
    Y = [g && {
      dayOfWeek: "Sunday",
      opens: X(m),
      closes: X(y)
    }, u && {
      dayOfWeek: "Monday",
      opens: X(h),
      closes: X(f)
    }, O && {
      dayOfWeek: "Tuesday",
      opens: X(T),
      closes: X(w)
    }, S && {
      dayOfWeek: "Wednesday",
      opens: X(C),
      closes: X($)
    }, v && {
      dayOfWeek: "Thursday",
      opens: X(E),
      closes: X(b)
    }, N && {
      dayOfWeek: "Friday",
      opens: X(R),
      closes: X(k)
    }, W && {
      dayOfWeek: "Saturday",
      opens: X(F),
      closes: X(P)
    }].filter(Boolean).map(function (_ref2) {
      var e = _ref2.dayOfWeek,
        n = _ref2.opens,
        a = _ref2.closes;
      return {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: "http://schema.org/".concat(e),
        opens: n,
        closes: a
      };
    }),
    Z = {
      "@context": "http://www.schema.org",
      "@type": t,
      name: n,
      url: "".concat(a, "/"),
      logo: L ? s : "".concat(a).concat(s),
      image: L ? i : "".concat(a).concat(i),
      description: r,
      telephone: o,
      award: U,
      knowsLanguage: q,
      sameAs: K,
      address: {
        "@type": "PostalAddress",
        streetAddress: d,
        addressLocality: l,
        addressRegion: p,
        postalCode: c,
        addressCountry: "US"
      },
      openingHoursSpecification: Y,
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Service Offers",
        itemListElement: I
      },
      brand: B,
      hasCredential: Q,
      memberOf: G
    },
    ee = (ne = j, Object.keys(ne).length);
  var ne;
  var ae = 0;
  var te = M;
  for (var _e2 = 0; _e2 < te.length; _e2 += 1) ae += te[_e2].rating;
  var se = ae / ee;
  se = se.toFixed(1);
  var ie = x.map(function (e) {
      var n = JSON.stringify(e.comments);
      n = n.replace(/\\n/g, "");
      var a = e.rating > 0 ? Math.min(e.rating, 5) : 1,
        t = (e.reviewerFirstName || e.reviewerLastName) && "".concat(e.reviewerFirstName || "", " ").concat(e.reviewerLastName || "").trim() || "Anonymous";
      return "{\n      \"@type\": \"Review\",\n      \"datePublished\": \"".concat(e.reviewDate, "\",\n      \"reviewRating\": {\n        \"@type\": \"Rating\",\n        \"ratingValue\": \"").concat(a, "\"\n      },\n      \"author\": {\n        \"@type\": \"Person\",\n        \"name\": \"").concat(t, "\"\n      },\n      \"description\": ").concat(n, ",\n      \"itemReviewed\": {\n        \"@type\": \"Thing\",\n        \"name\": \"").concat(e.businessName, "\"\n      }\n    }");
    }),
    re = {
      "@context": "http://schema.org",
      "@type": "Product",
      aggregateRating: {
        "@type": "AggregateRating",
        bestRating: 5,
        ratingValue: se,
        reviewCount: te.length,
        worstRating: 1
      },
      brand: {
        "@type": "Brand",
        name: n
      },
      image: i,
      name: n,
      review: JSON.parse("[".concat(ie.join(","), "]"))
    };
  return e.createElement(e.Fragment, null, e.createElement("script", {
    async: !0,
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(Z, null, 2)
    }
  }), e.createElement("script", {
    async: !0,
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(re, null, 2)
    }
  }));
};
export { n as GeneralSchema };